import './App.css';
import Game from './Game';

function App() {
  return (
    <div
      className="App"
      style={{
        '--game-background': `url("${process.env.PUBLIC_URL}/backgrounds/microbes-airy-mint.webp")`
      }}
    >
      <Game />
    </div>
  );
}

export default App;
